import useEstimateRenewal from "features/subscriptions/datahooks/useEstimateRenewal";
import {
  formatPricingPeriodInfo,
  parseEstimate,
} from "features/subscriptions/utils";

import type { PricingPeriodInfo } from "common/types";

import Price from "./Price";

export default function CustomerSubRenewalPrice({
  pricingPeriodInfo,
}: {
  pricingPeriodInfo: PricingPeriodInfo;
}) {
  const { estimateRenewal, isLoadingEstimateRenewal } = useEstimateRenewal();

  let priceValue = 0;
  let priceSubtext: string;

  if (estimateRenewal) {
    const parsedEstimate = parseEstimate(estimateRenewal);

    priceValue = parsedEstimate.amountDue;
    priceSubtext = formatPricingPeriodInfo(pricingPeriodInfo);
  }

  return (
    <Price
      priceValue={priceValue}
      priceSubtext={priceSubtext}
      isLoading={isLoadingEstimateRenewal}
    />
  );
}
